<template>
  <instructions-component
    class="pointer-events-auto midder"
    :header="$t('instructions')"
    :button-text="$t('continue')"
    :cards="getInstructions"
    show-button
    @button-click="closeInstructions"
  />
</template>

<script lang="ts">
import { Instructions } from '@powerplay/core-minigames-ui-ssm'
import {
  CorePhases,
  corePhasesManager,
  modes,
  requestManager,
  tutorialManager
} from '@powerplay/core-minigames'
import { pathAssets } from '@/globals/globalvariables'

import { defineComponent } from 'vue'
import { blurState } from '@/stores'

export default defineComponent({
  name: 'InstructionComponent',
  components: {
    InstructionsComponent: Instructions
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close-instructions'],
  computed: {
    getInstructions() {

      blurState().isActive = true
      const { disciplineID } = requestManager

      if (modes.isTrainingMode()) {

        return [
          {
            imgSrc: `${pathAssets}/ui/instructions/training-1.png`,
            header: this.$t(`instructionsDisciplineTraining${disciplineID}Cell1Title`),
            text: [this.$t(`instructionsDisciplineTraining${disciplineID}Cell1Text1`)]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-2v2.png`,
            header: this.$t(`instructionsDisciplineTraining${disciplineID}Cell2Title`),
            text: [this.$t(`instructionsDisciplineTraining${disciplineID}Cell2Text1`)]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-3.png`,
            header: this.$t(`instructionsDisciplineTraining${disciplineID}Cell3Title`),
            text: [this.$t(`instructionsDisciplineTraining${disciplineID}Cell3Text1`).replace('[number]', '5')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-4.png`,
            header: this.$t(`instructionsDisciplineTraining${disciplineID}Cell4Title`),
            text: [this.$t(`instructionsDisciplineTraining${disciplineID}Cell4Text1`)]
          }
        ]

      }

      const mobilePart = this.isMobile ? 'Mobile' : ''

      return [
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-1${mobilePart}.png`,
          header: this.$t(`instructionsDiscipline${disciplineID}Cell1Title`),
          text: [this.$t(`instructionsDiscipline${disciplineID}Cell1Text1`)]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-2.png`,
          header: this.$t(`instructionsDiscipline${disciplineID}Cell2Title`),
          text: [
            this.$t(`instructionsDiscipline${disciplineID}Cell2Text1${mobilePart}`),
            this.$t(`instructionsDiscipline${disciplineID}Cell2Text2`)
          ]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-3.png`,
          header: this.$t(`instructionsDiscipline${disciplineID}Cell3Title`),
          text: [
            this.$t(`instructionsDiscipline${disciplineID}Cell3Text1`),
            this.$t(`instructionsDiscipline${disciplineID}Cell3Text2`)
          ]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-4v2.png`,
          header: this.$t(`instructionsDiscipline${disciplineID}Cell4Title`),
          text: [
            this.$t(`instructionsDiscipline${disciplineID}Cell4Text1`),
            this.$t(`instructionsDiscipline${disciplineID}Cell4Text2`)
          ]
        }
      ]

    }
  },
  methods: {
    closeInstructions(): void {

      // pokial mame prvotne instrukcie, tak ich zavrieme
      if (corePhasesManager.isActivePhaseByType(CorePhases.instructions)) {

        corePhasesManager.getActualPhase()?.finishPhase()

      }
      this.$emit('close-instructions')
      tutorialManager.blockInputsManually(1000)

    }
  }
})
</script>

<style lang="less" scoped>
</style>
